import Block from 'quill/blots/block.js';

export class CustomBlockQuote extends Block {
    static override blotName = 'blockquote';
    static override tagName = 'blockquote';

    static override create(value: any) {
        const node = super.create(value);
        node.style.margin = '0';
        node.style.paddingLeft = '16px';
        node.style.borderLeft = '4px solid rgb(204, 204, 204)';
        return node;
    }
}
